import { useEffect, useLayoutEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const positions = new Map<string, number>();

const appScroller = () => document.querySelector<HTMLElement>('main');

export const scrollAppToTop = () => {
	const scroller = appScroller();
	if (scroller) scroller.scrollTop = 0;
	else window.scrollTo({ top: 0 });
};

export const useScrollMemory = () => {
	const location = useLocation();
	const navigationType = useNavigationType();
	const shown = useRef({ key: '', pathname: '' });

	useEffect(() => {
		const scroller = appScroller();
		if (!scroller) return;
		const remember = () => positions.set(shown.current.key, scroller.scrollTop);
		scroller.addEventListener('scroll', remember, { passive: true });
		return () => scroller.removeEventListener('scroll', remember);
	}, []);

	useLayoutEffect(() => {
		const previous = shown.current;
		shown.current = { key: location.key, pathname: location.pathname };
		const scroller = appScroller();
		if (!scroller) return;
		const saved = positions.get(location.key);
		if (navigationType === 'POP') {
			if (saved !== undefined) scroller.scrollTop = saved;
			return;
		}
		if (previous.pathname !== location.pathname) scroller.scrollTop = 0;
	}, [location.key, location.pathname, navigationType]);
};
